import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_SA_TARGET:
      return { ...state, shiftDetails: action.payload };
    case ACTION_TYPES.FETCH_SA_REASON_CODES:
      return { ...state, schAttainmentReasonCodes: action.payload };
    case ACTION_TYPES.FETCH_SA_DAILY_INPUT_DETAILS:
      return { ...state, dailyInputDetails: action.payload };
    case ACTION_TYPES.REFRESH_SCH_ATTAINMENT_WIDGET:
      return { ...state, refreshSchAttainment: action.payload };
    case ACTION_TYPES.FETCH_SCH_ATTAINMENT_RUN_CHART: {
      return { ...state, runChartData: action.payload };
    }
    case ACTION_TYPES.FETCH_SCH_ATTAINMENT_MISS_REASON_CODE_FREQ: {
      return { ...state, missReasonCodeFrequency: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_O": {
      return { ...state, level0Codes: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_1": {
      return { ...state, level1Codes: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_2": {
      return { ...state, level2Codes: action.payload };
    }
    default:
      return state;
  }
};
